__turbopack_context__.v({
  "categoryIcon": "gpIWYa_categoryIcon",
  "categoryLabelWrapper": "gpIWYa_categoryLabelWrapper",
  "categoryRowValue": "gpIWYa_categoryRowValue",
  "categoryWrapper": "gpIWYa_categoryWrapper",
  "chevronIcon": "gpIWYa_chevronIcon",
  "comparisonSection": "gpIWYa_comparisonSection",
  "comparisonTitle": "gpIWYa_comparisonTitle",
  "dataRow": "gpIWYa_dataRow",
  "expandedContent": "gpIWYa_expandedContent",
  "gridRow": "gpIWYa_gridRow",
  "headerCell": "gpIWYa_headerCell",
  "headerRow": "gpIWYa_headerRow",
  "rowLabel": "gpIWYa_rowLabel",
  "rowLabelContainer": "gpIWYa_rowLabelContainer",
  "rowValue": "gpIWYa_rowValue",
  "tableContainer": "gpIWYa_tableContainer",
  "testName": "gpIWYa_testName",
  "testRow": "gpIWYa_testRow",
  "testValue": "gpIWYa_testValue",
});
